import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'shorten',
})
export class ShortenPipe implements PipeTransform {
  transform(value: any, maxLength: number = 144) {
    if (!value) {
      return value;
    }

    // const temp = document.createElement('div');
    // temp.innerHTML = value;
    // Converte entidades HTML para caracteres normais
    // const text = temp.textContent || temp.innerText || '';
    // Remove espaços múltiplos e quebras de linha
    // const cleanText = text.replace(/\s+/g, ' ').trim();
    // if (cleanText.length > maxLength) {
    //   return cleanText.slice(0, maxLength) + '...';
    // }

    // Constante é usada para ignorar tags html.
    const str = value.replace(/<[^>]*>/g, '');
    // Tamanho máximo de caracteres para os textos.
    if (str.length > maxLength) {
      // return value.substr(0, maxLength) + '...';
      return str.substr(0, maxLength) + '...';
    }
    return value;
  }
}
